module.exports = __webpack_public_path__ + "static/progSuperman-4fb071281898c9063c0a8817c44827ba.jpg";